import { useState, useEffect, useCallback } from 'react';
import API from '../api/phx';
import * as utils from '../utils/OrderUtils';

const useOpenHours = (orderId) => {
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const checkOpenHours = useCallback(async () => {
    setLoading(true);
    try {
      const openHoursUrl = utils.appendGeoParam('/five9/openHours');
      const response = await API.post(openHoursUrl, { orderId });
      setIsOpen(response.data.is_open === 1);
      setError(null);
    } catch (err) {
      setIsOpen(false);
      console.error('Error fetching open hours:', err);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [orderId]);

  useEffect(() => {
    checkOpenHours();
  }, [checkOpenHours]);

  return {
    isOpen, loading, error, checkOpenHours,
  };
};

export default useOpenHours;
